export default {
  namespaced: true,

  state: {
    dates: { // always
      companyStartDate: '',
      companyEndDate: '',
      mobilityStartDate: '',
      mobilityEndDate: '',
    },

    general: {
      name: '', // always
      mobile: '',
      email: '',
      url: '',
    },

    address: { // always
      street: '',
      postalCode: '',
      city: '',
      country: '',
    },

    language: {
      ects: '', // always
      lang: '', // always
      prep: '',
      langIsNational: false,
      previousErasmus: false,
      previousBelgica: false,
    },

    type: {
      members: null,
      visibility: null,
      commercial: null,
      sector: '',
      type: '',
    },
  },

  mutations: {
    SET_DATES(state, data) {
      state.dates[data.key] = data.value;
    },

    SET_GENERAL(state, data) {
      state.general[data.key] = data.value;
    },

    SET_ADDRESS(state, data) {
      state.address[data.key] = data.value;
    },

    SET_LANGUAGE(state, data) {
      state.language[data.key] = data.value;
    },

    SET_TYPE(state, data) {
      state.type[data.key] = data.value;
    },
  },
};
